import { render, staticRenderFns } from "./AddFeaturesModal.vue?vue&type=template&id=0f58bb24&"
import script from "./AddFeaturesModal.vue?vue&type=script&lang=js&"
export * from "./AddFeaturesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports